import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import environment from '@environments/environment';
import {
  DocumentDownloadResponse,
  DownloadRequest,
  ExportRequest,
  DocumentExportResponse,
  DocumentLinkResponse,
  DocumentDownload,
  DocumentExport,
} from '../types';
import { Observable } from 'rxjs';
import { WcgTableValues } from '@shared/interfaces/wcg-table-utils.interface';
@Injectable({
  providedIn: 'root',
})
export class DownloadsExportsService {
  private readonly _http = inject(HttpClient);
  private readonly _wcgTableUtils = inject(WcgTableUtilsService);

  downloadDocumentBundle(downloadRequest: DownloadRequest) {
    return this._http.post<DocumentDownload>(
      `${environment.irisApi}/v2/document/bundle/`,
      downloadRequest,
    );
  }

  /**
   * ERM-12396/12397 "Download all documents": added a `download_all` flag to the same `/v2/document/bundle/`
   * endpoint `downloadDocumentBundle` already uses (`app/document/router_v2.py`), which bundles
   * every uploaded, non-removed submission document, ignoring `ids`.
   * @param studyId The submission's study id.
   * @param workspaceId The submission workspace whose documents are bundled.
   * @param data Timezone hints the BE stamps on the bundle.
   * @returns The created download resource.
   */
  downloadAllSubmissionDocuments(
    studyId: string,
    workspaceId: string,
    data: WcgTableValues,
  ) {
    return this.downloadDocumentBundle({
      data,
      download_all: true,
      entity_id: workspaceId,
      entity_type: 'workspace',
      ids: [],
      is_outcome: false,
      study_id: studyId,
    });
  }
  exportDocumentBundle(exportRequest: ExportRequest) {
    const { url, wcgTableValues, args } = exportRequest;
    let queryParams =
      this._wcgTableUtils.generateTableQueryParams(wcgTableValues);
    if (args) {
      for (const [key, value] of Object.entries(args)) {
        if (value !== undefined) {
          queryParams = queryParams.append(key, String(value));
        }
      }
    }
    return this._http.get<DocumentExport>(url, { params: queryParams });
  }
  getDocumentDownloads(params: {
    category: string;
  }): Observable<DocumentDownloadResponse> {
    return this._http.get<DocumentDownloadResponse>(
      `${environment.irisApi}/resources/`,
      { params },
    );
  }
  getDocumentLink(id: string) {
    return this._http.get<DocumentLinkResponse>(
      `${environment.irisApi}/resource/${id}/`,
    );
  }

  getDocumentExports(params: {
    category: string;
  }): Observable<DocumentExportResponse> {
    return this._http.get<DocumentExportResponse>(
      `${environment.irisApi}/resources/`,
      { params },
    );
  }
}
